export default "__VITE_PUBLIC_ASSET__82891f2c__"